$(function () {
    $('.home-slider').owlCarousel({
        items: 1,
        margin: 5,
        rtl: true,
        autoplay: true,
        lazyLoad: true,
        nav: true,
        loop: true,
        navText: [
            "<i class='icon icon-big-angle-right text-dark'></i>",
            "<i class='icon icon-big-angle-left text-dark'></i>",
        ],
    });

    $('.special-pool-slider').owlCarousel({
        items: 4,
        margin: 25,
        rtl: true,
        autoplay: false,
        lazyLoad: true,
        nav: true,
        dots: false,
        loop: false,
        responsive: {
            0: {
                items: 3,
            },
            1200: {
                items: 4,
            },
        },
        navText: [
            "<i class='icon icon-big-angle-right text-dark'></i>",
            "<i class='icon icon-big-angle-left text-dark'></i>",
        ],
    });

    $('.pool-slider').owlCarousel({
        items: 3,
        margin: 25,
        rtl: true,
        autoplay: false,
        lazyLoad: true,
        dots: false,
        nav: true,
        loop: false,
        responsive: {
            0: {
                items: 2,
            },
            1200: {
                items: 3,
            },
        },
        navText: [
            "<i class='icon icon-big-angle-right text-dark'></i>",
            "<i class='icon icon-big-angle-left text-dark'></i>",
        ],
    })

    $('#reserv-btn').on('click', function (e) {
        e.preventDefault()
        var urlResrve = $('.owl-stage-outer .active').find('img').closest("a").attr('href');
        if (urlResrve !== undefined || urlResrve !== null )
            window.location.href =urlResrve;
    });

    /****
     * Poll Modal
     ****/
    let modal = undefined;
    // Auto show poll modal
    if (document.getElementById("poll-modal")) {
        modal = new bootstrap.Modal(document.getElementById("poll-modal"), {});
        modal.show();
    }

    // Accept poll
    $(document).on('click','#poll-modal-submission', function(){
        $("#poll-modal .form-content").css("display","none");
        $("#poll-modal .ifram-content").css("display","block");
        $("#poll-modal .ifram-content").html(`<iframe src="${$('#poll-modal-submission').attr("data-href")}" style="width: 100%;height: fit-content;min-height: 820px" ></iframe>`);
    });

    // Dissmis poll modal
    $('.poll-dont-want').on('click', function() {
        var id = $('#poll-modal').data('purchase');
        var token = $('#poll-modal').data('token');
        $.ajax({
            url: window.BASE_URL + '/pool-survey/' + id + '/' + token + '/set-dont-want',
            method: 'POST',
            cache: false,
            dataType: 'json',
            complete: function() {
                modal.hide();
            }
        });
    });

    // Close modal when poll completed
    var bc = new BroadcastChannel('survey_iframe');
    bc.onmessage = function(event) {
        modal.hide();
    }

    // timer
    $('[id^="count-down-timer-"]').each(function (i, obj) {
        let elementId = $(this).attr('id');
        let datetime = $(this).attr('datetime');

        var countDownDate = new Date(datetime).getTime();

        // Update the count down every 1 second
        var x = setInterval(function () {

            // Get todays date and time
            var now = new Date().getTime();

            // Find the distance between now an the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            hours = hours < 10
                ? '0' + hours.toString().toPersianDigits()
                : hours.toString().toPersianDigits();

            minutes = minutes < 10
                ? '0' + minutes.toString().toPersianDigits()
                : minutes.toString().toPersianDigits();

            // Output the result in an element with id="demo"
            document.getElementById(elementId).innerHTML = hours.toString().toPersianDigits() + " : "
                + minutes.toString().toPersianDigits() + " : " + seconds.toString().toPersianDigits();

            // If the count down is over, write some text
            if (distance < 0) {
                clearInterval(x);
                document.getElementById(elementId).innerHTML = "منقضی شده";
            }
        }, 1000);

    });

    // copy-it
    var clipboard = new ClipboardJS('.copy-it', {
        text: function (trigger) {
            return $(trigger).attr('data-value').trim();
        }
    });

    clipboard.on('success', function (e) {
        $(e.trigger).tooltip({
            title: 'کپی شد',
            placement: 'bottom',
            trigger: 'manual',
            container: 'body'
        }).tooltip('show');

        setTimeout(function () {
            $(e.trigger).tooltip('hide').tooltip('dispose');
        }, 2000);
    });

    $('.special-poolparty-slider').owlCarousel({
        items: 3,
        margin: 20,
        rtl: true,
        autoplay: false,
        lazyLoad: true,
        nav: true,
        dots: false,
        loop: false,
        responsive: {
            0: {
                items: 3,
            },
            1200: {
                items: 4,
            },
        },
        navText: [
            "<i class='icon icon-big-angle-right'></i>",
            "<i class='icon icon-big-angle-left'></i>",
        ],
    });

});